import type { Message } from './apiModels'

export type SideJobReport = {
  kind: 'formatted'
  outcome: 'finished' | 'failed'
  title: string
  topicPath: string
  body: string
} | {
  kind: 'unparsed'
  body: string
}

export function getSideJobReport(
  message: Pick<Message, 'direction' | 'user' | 'external_message_id' | 'body'>,
): SideJobReport | null {
  if (message.direction !== 'inbound' || message.user !== 'system:lane-topic'
    || !message.external_message_id?.startsWith('lane-topic-report:')) return null

  const body = message.body.replace(/\r\n/g, '\n')
  const fallback: SideJobReport = { kind: 'unparsed', body }
  const header = /^Side job (finished|FAILED): ([^\n]+)\nReported by system:lane-topic; this is not a message from Mark\.\nSide topic: ([^\n]+)\n\n(?:Its final reply:|Its last output before it stopped:)\n/.exec(body)
  if (!header) return fallback

  const remainder = body.slice(header[0].length)
  const handoffAt = remainder.indexOf('\n\nYou opened this side job, so you own it.')
  if (handoffAt < 0) return fallback
  const quotedLines = remainder.slice(0, handoffAt).split('\n')
  if (!quotedLines.every((line) => line === '>' || line.startsWith('> '))) return fallback

  let url: URL
  try {
    url = new URL(header[3])
  } catch {
    return fallback
  }
  if (!['https:', 'http:'].includes(url.protocol) || !url.pathname.startsWith('/chats/')) return fallback

  return {
    kind: 'formatted',
    outcome: header[1] === 'FAILED' ? 'failed' : 'finished',
    title: header[2],
    topicPath: `${url.pathname}${url.search}${url.hash}`,
    body: quotedLines.map((line) => line === '>' ? '' : line.slice(2)).join('\n'),
  }
}
